import { NgTemplateOutlet } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';

import { ConnectedIntegrationRow } from 'src/app/settings/services/integrations/models/integrations.types';

export type IntegrationConnectedRowScope = 'company' | 'user';

@Component({
  selector: 'integration-connected-row',
  templateUrl: './integration-connected-row.component.html',
  styleUrl: './integration-connected-row.component.scss',
  standalone: true,
  imports: [
    NgTemplateOutlet,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatTooltipModule,
  ],
})
export class IntegrationConnectedRowComponent {
  @Input({ required: true }) integration!: ConnectedIntegrationRow;
  /** Drives logo framing: company uses logo-inset scale; user sizes the icon. */
  @Input({ required: true }) scope!: IntegrationConnectedRowScope;
  @Input() hideManage = false;

  @Output() manage = new EventEmitter<ConnectedIntegrationRow>();
  @Output() reconnect = new EventEmitter<ConnectedIntegrationRow>();
  @Output() disconnect = new EventEmitter<ConnectedIntegrationRow>();

  get isExpiredStatus(): boolean {
    return this.integration.status === 'expired';
  }

  get isUnknownStatus(): boolean {
    return this.integration.status === 'unknown';
  }

  get isConnectedStatus(): boolean {
    return this.integration.status === 'connected';
  }

  get statusLabel(): string {
    switch (this.integration.status) {
      case 'expired':
        return 'Expired';
      case 'unknown':
        return 'Unknown';
      default:
        return 'Connected';
    }
  }
}
